import(/* webpackMode: "eager" */ "/pri/app/globals.css");
import(/* webpackMode: "eager" */ "/pri/components/sentry-provider.tsx");
import(/* webpackMode: "eager" */ "/pri/components/theme-provider.tsx");
import(/* webpackMode: "eager" */ "/pri/components/ui/toaster.tsx");
import(/* webpackMode: "eager" */ "/pri/components/ui/tooltip.tsx")